module.exports = __webpack_public_path__ + "static/media/lobby-bg.4cd9e11b.webp";